import * as constants from '../constants';
import textButton from './text-button';

const width = 200;
const height = 25;

export default function() {
  const c = new PIXI.Container();

  const btn = textButton({ text: '', bgColour: constants.lightBlue, width, height }); 
  c.addChild(btn);
  btn.x = width / 2;
  btn.y = height / 2;

  let showingCorrectSolution;
  let question;

  Object.defineProperty(c, 'showingCorrectSolution', {
    set: val => {
      showingCorrectSolution = !!val;
      btn.label.text = showingCorrectSolution ? 'See your answer' : 'See correct solution';
    },
    get: () => {
      return showingCorrectSolution;
    }
  });

  Object.defineProperty(c, 'question', {
    set: val => question = val
  });

  btn.on('pointerdown', () => {
    c.showingCorrectSolution = !c.showingCorrectSolution;
    if ( c.showingCorrectSolution ) {
      question.tool.showCorrectSolution(question);
    } else {
      question.tool.showUserSolution(question);
    }
  });

  c.showingCorrectSolution = false;

  return c;
};
